const overlay = () => document.getElementById("loading-overlay");

const start = (text = "") => {
  const el = overlay();
  if (!el) return;
  el.classList.remove("hidden");
  el.removeAttribute("hidden");
  el.setAttribute("aria-hidden", "false");
  const message = el.querySelector(".message");
  if (message) message.textContent = text;
  document.body.classList.add("overflow-hidden");
};

const stop = () => {
  const el = overlay();
  if (!el) return;
  el.classList.add("hidden");
  el.setAttribute("hidden", "");
  el.setAttribute("aria-hidden", "true");
  const message = el.querySelector(".message");
  if (message) message.textContent = "";
  document.body.classList.remove("overflow-hidden");
};

export default { start, stop };
